import { Resource } from "../resource/resource.model";

/**
 * 4Bridge Integration Model
 * Represents a data integration between two connections
 */
export class BridgeIntegration extends Resource {
    name: string;
    description?: string;
    sourceConnectionId: string;
    sourceConnectionName?: string;
    sourceConnectorType?: string;
    targetConnectionId: string;
    targetConnectionName?: string;
    targetConnectorType?: string;
    // Legacy fields - derived from tasks for display
    sourceObject?: string;
    targetObject?: string;
    isEnabled?: boolean;
    isActive?: boolean;
    isPublished?: boolean;
    taskCount?: number;
    status?: string;
    lastSyncAt?: Date;
    createdAt?: Date;
    updatedAt?: Date;
}

/**
 * Field mapping configuration
 */
export interface FieldMapping {
    sourceField: string;
    targetField: string;
    transformation?: string;
    defaultValue?: string;
    isRequired?: boolean;
    // Marketo consent-sync fields (F4): wire-format keys matching the 4Bridge worker's
    // FieldMapping entity (source_config/transform_rules siblings), distinct from defaultValue above.
    constant_value?: string;
    default_value?: string;
}

/**
 * Post-mapping conditional rule applied to the destination record (Marketo consent-sync / F4).
 * Mirrors the 4Bridge worker's MappingRule entity field-for-field.
 */
export interface BridgeMappingRule {
    equals_value: string;
    only_if_empty: boolean;
    set_field: string;
    set_value: string;
    when_field: string;
}

/**
 * Request DTO for creating an integration
 */
export interface CreateIntegrationRequest {
    name: string;
    description?: string;
    sourceConnectionId: string;
    targetConnectionId: string;
    isPublished?: boolean;
}

/**
 * Request DTO for updating an integration
 */
export interface UpdateIntegrationRequest {
    name?: string;
    description?: string;
    sourceConnectionId?: string;
    targetConnectionId?: string;
    isPublished?: boolean;
}

/**
 * Schedule type enum
 */
export enum ScheduleType {
    MANUAL = 'manual',
    CRON = 'cron',
    WEBHOOK = 'webhook'
}

/**
 * Integration status enum
 */
export enum IntegrationStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    SYNCING = 'syncing',
    ERROR = 'error'
}
